import React, { useState } from "react";
import { Box, Button, Checkbox, Container, FormControl, Grid, IconButton, InputLabel, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { Ayudantia, AyudantiaInvestigacion, AyudantiaInvestigacionData, ResponseAprobacion, solicitudAprobacionDTO, voidAyudantiaInvestigacionData } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";
import { MdCheck, MdClose, MdDetails, MdEditDocument, MdSearch } from "react-icons/md";
import { SmallModal } from "../../common/SmallModal";
import AlertService from "../../services/AlertService";
import { AccionSolicitudAyudantia } from "../Formularios/AccionSolicitudAyudantia";
import { useAppSelector } from "../../redux/hooks";
import { ResponseApi } from "../../types/ResponseApi";
import AyudantiaService from "../../services/AyudantiaService";
import { DatosGeneralesProyecto, VoidDatosGeneralesProyecto } from "../../interfaces/AYUDANTIAS/DatosGenProyecto";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import AcademicoService from "../../services/AcademicoService";
import { EstudianteActivoT, VoidEstudianteActivo } from "../../interfaces/SAAC/EstudianteActivo";
import { AccionMultipleForm } from "../Formularios/AccionMultipleForm";


interface Props {
  solicitudes: AyudantiaInvestigacionData[],
  showImpedimento : boolean,
  showRechazarTodo: boolean,
  onActionAprobadas?: () => void,
  onActionPendientes?: () => void,
  onActionRechazadas?: () => void,
  rowsPerPage: Array<number>,
  tipoPersona: string,
  sonPendientes: boolean

  // rowsPerPage: number;
  // setRowsPerPage: (value: number) => void;
  // searchTerm: string;
  // setSearchTerm: (value: string) => void;
  // displayedRows: { idProyecto: number; titulo: string; estado: string }[];
  // totalPages: number;
  // currentPage: number;
  // handlePageChange: (event: any, value: number) => void;
}

const ayudantiaService = new AyudantiaService();
const alertaService = new AlertService();
const academicoService = new AcademicoService();
export const SolicitudesAyudTable: React.FC<Props> = ({ 
  solicitudes,showImpedimento, showRechazarTodo, onActionAprobadas, onActionPendientes, onActionRechazadas, rowsPerPage, tipoPersona, sonPendientes
// 
 }) => {

  //console.log("SOLICITUDES APROBADAS")
  //console.log(solicitudes)
  const token = useAppSelector((state) => state.authReducer.token);
  const [isModalDetalle, setIsModalDetalle] = React.useState<boolean>(false);
  const [isModalRechazar, setIsModalRechazar] = React.useState<boolean>(false);
  const [detalleData, setDetalleData] = React.useState<AyudantiaInvestigacionData>(voidAyudantiaInvestigacionData());
  const [estudiante, setEstudiante] = React.useState<EstudianteActivoT>(VoidEstudianteActivo());
  const [datosProyecto, setDatosProyecto] = React.useState<DatosGeneralesProyecto>(VoidDatosGeneralesProyecto());
  ///let solicitudesARechazar: AyudantiaInvestigacionData[] = [];
  const [tipoBoton, settipoBoton] = useState<string>('');
  const [page, setPage] = React.useState(0);
  const [rowsperpage, setRowsPerPage] = React.useState(rowsPerPage[0]);
  const [solicitudesARechazar, setSolicitudesARechazar] = useState<Array<AyudantiaInvestigacionData>>([]);
  const [globalFilter, setGlobalFilter] = useState('');

  const constFilteredSolicitud = solicitudes.filter((solicitud) => {
    if(solicitud.nombreProyecto.toUpperCase().includes(globalFilter.toUpperCase())  
        || solicitud.nombreEstudiante.toUpperCase().includes(globalFilter.toUpperCase()) 
        || solicitud.codestudiante.toUpperCase().includes(globalFilter.toUpperCase())
        || solicitud.nombreInvestigador.toUpperCase().includes(globalFilter.toUpperCase())
        || solicitud.fechasolicitud.toUpperCase().includes(globalFilter.toUpperCase())
        || solicitud.estadoPaso.toUpperCase().includes(globalFilter.toUpperCase())
        || solicitud.horasOtorgadas.toString().includes(globalFilter)
    ){
        return true;
    }
    return false;
})

  const handleOpenModal = async (data : AyudantiaInvestigacionData, tipoBoton: string) => {
    alertaService.showLoading("Cargando información...");
    let DatosProyectos =  (await ayudantiaService.GetDatosGeneralesProyecto(token, data.idproyecto));
    setDatosProyecto(DatosProyectos.status.isSuccessfully ? DatosProyectos.data : VoidDatosGeneralesProyecto());
    let estudianteCarrera =  await academicoService.GetCarreraActivaByMatricula(token, data.codestudiante,'I');
    setEstudiante(estudianteCarrera.status.isSuccessfully ? estudianteCarrera.data : VoidEstudianteActivo());
    setDetalleData(data);
    settipoBoton(tipoBoton)
    setTimeout(() => {
      setIsModalDetalle(true);
      alertaService.hideLoading();
    }, 500);
  };

  const handleCloseModal = () => {
    document.activeElement instanceof HTMLElement && document.activeElement.blur();
    setIsModalDetalle(false);
  };

  const handleOpenModalRechazar = async () => {
    alertaService.showLoading("Procesando información...");
    setTimeout(() => {
      setIsModalRechazar(true);
      alertaService.hideLoading();
    }, 500);
  };

  const handleCloseModalRechazo = () => {
    document.activeElement instanceof HTMLElement && document.activeElement.blur();
    setIsModalRechazar(false);
  };

  const handleCheckSolicitud = (solicitud: AyudantiaInvestigacionData, event: React.ChangeEvent<HTMLInputElement>) => {
    setSolicitudesARechazar((prevSelected) => 
      event.target.checked
        ? [...prevSelected, solicitud] // Agrega si está checkeado
        : prevSelected.filter(item => item.iddetallesolicitud !== solicitud.iddetallesolicitud) // Quita si se desmarca
    );
  };

  const handleCheckAllSolicitudes = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSolicitudesARechazar(event.target.checked ? [...solicitudes] : []);
  };

  const handleCheckAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSolicitudesARechazar(event.target.checked ? [...solicitudes] : []);
  };

  const handleResponseForm = async (responseData: ResponseApi<ResponseAprobacion>) => {
    
    if (responseData.status.isSuccessfully) {
      if(responseData.listData.length<=0){
        //alertaService.hideLoading();
        alertaService.alertaExito("éxito", "La solicitud fue aprobada de manera correcta");
        setTimeout(() => {
          if(onActionPendientes)
            onActionPendientes();
          if(onActionAprobadas)
            onActionAprobadas();
        }, 1500);
      }else{
        //alertaService.hideLoading();
        let solicitudesNoAprobadas: string[] = [];

        responseData.listData.map((data)=>{
          let detalle = "Matricula: "+data.codestudiante+", Estudiante: "+data.nombreEstudiante+", Impedimentos: "+data.impedimentos;
          solicitudesNoAprobadas.push(detalle);
        })

        alertaService.alertaAdvertenciaListSolicitudes("Alerta",solicitudesNoAprobadas);
      }
      
    }
  };
  
  const handleResponseFormRechazo = async (responseData: ResponseApi<solicitudAprobacionDTO>) => {
    //setIsModalRechazar(false);
    if (responseData.status.isSuccessfully) {
      alertaService.alertaExito("éxito", "Se procesaron los datos correctamente.");
      setTimeout(() => {
        if(onActionPendientes)
          onActionPendientes()
        if(onActionRechazadas)
          onActionRechazadas()
      }, 1500);
      
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
  };


  function estadoTexto(estado:string):string{
    let texto = '';
    switch(estado){
      case 'P':
        texto = 'Pendiente';
        break;
      case 'A':
        texto = 'Aprobado';
        break;
      case 'N':
        texto = 'Rechazado';
        break;
      case 'X':
        texto = 'Anulada';
        break;
      case 'R':
        texto = 'Reservado-Aprobado';
        break;
      case 'E':
        texto = 'Reservado-Rechazado';
        break;
      case 'G':
        texto = 'Negado-Aprobado';
        break;
      default:
         return '';
    }
    return texto;
  }

  return (
      
    <Container>
      {
        showRechazarTodo ?
        solicitudesARechazar.length>0 ?

        <Button size="small"
          variant="contained"
          sx={{
            marginRight: 1, backgroundColor: "#F44336",
            color: "#FFFFFF !important",
            "&:hover": { backgroundColor: "#E57373" },
            boxShadow: 3, margin: "10px"
          }}
        
          endIcon={<MdClose />}
          onClick={()=>{handleOpenModalRechazar()}}
          >
          Rechazar todo
        </Button>
        :null
        :null
      }

      <TextField
          variant="outlined"
          size="small"
          label="Busqueda General"
          //value={searchTerm}
          onChange={(e) => setGlobalFilter(e.target.value)}
          sx={{ width: 300 }}
      />
      <br />
      <br />
      
      <TableContainer  component={Paper} elevation={3}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#243165" }}>
             {
                showRechazarTodo ?
                <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                  <Checkbox onChange={(event) => handleCheckAllSolicitudes(event)} />
                </TableCell>
                :null

              }
              
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del proyecto</TableCell>
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del Ayudante</TableCell>
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Matrícula</TableCell>
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del Investigador</TableCell>
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Fecha de la solicitud</TableCell>
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Estado</TableCell>
              {
                showImpedimento ?
                <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Impedimento</TableCell>
                :null

              }
              {
                sonPendientes ?
                <>
                <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Financiamiento</TableCell>
                <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Horas</TableCell>
                </>
                :
                <></>
              }
              
              <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {constFilteredSolicitud.length > 0 ? (
              constFilteredSolicitud.slice(page * rowsperpage, page * rowsperpage + rowsperpage).map((solicitud, index) => (
                <TableRow key={index}>
                  {
                    showRechazarTodo ?
                    <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                      <Checkbox checked={solicitudesARechazar.some(item => item.iddetallesolicitud === solicitud.iddetallesolicitud)}
                      onChange={(event) => handleCheckSolicitud(solicitud,event)}
                      
                      />
                    </TableCell>
                    :null

                  }
                  <TableCell>{solicitud.nombreProyecto}</TableCell>
                  <TableCell>{solicitud.nombreEstudiante}</TableCell>
                  <TableCell>{solicitud.codestudiante}</TableCell>
                  <TableCell>{solicitud.nombreInvestigador}</TableCell>
                  <TableCell>{solicitud.fechasolicitud}</TableCell>
                  <TableCell>{estadoTexto(solicitud.estadoPaso)}</TableCell>
                  {
                    showImpedimento ?
                    <TableCell>
                    {
                      solicitud.estudianteImpedimentos!='' ?
                      <ul>
                        {solicitud.estudianteImpedimentos.split('|').map((est, index) => (
                          est.trim() !== '' ? <li key={`impedimento-${index}`}>{est}</li> : null
                        ))}
                      </ul>
                      :
                      <p>-</p>
                    }
                  </TableCell>
                  :null

                  }
                  {
                    sonPendientes ?
                    <>
                    <TableCell>{solicitud.financiamientoTexto}</TableCell>
                    <TableCell>{solicitud.horas}</TableCell>
                    </>
                    :
                    <></>
                  }
                  
                  <TableCell>
                    {
                      solicitud.estadoPaso == 'P' && !showImpedimento ?
                      //Puede aceptar o rechazar
                      <Grid container spacing={1}>
                        <Grid item>
                          <Button size="small"
                            variant="contained"
                            sx={{
                              marginRight: 1, backgroundColor: "#4CAF50",
                              color: "#FFFFFF !important",
                              "&:hover": { backgroundColor: "#81C784" },
                              boxShadow: 3,
                            }}
                            endIcon={<MdCheck />}
                            onClick={()=>{handleOpenModal(solicitud,"A")}}
                            >
                            Aceptar
                          </Button>
                        </Grid>

                        {
                          solicitudesARechazar.length <= 0 ?
                          <Grid item>
                            <Button size="small"
                              variant="contained"
                              sx={{
                                marginRight: 1, backgroundColor: "#F44336",
                                color: "#FFFFFF !important",
                                "&:hover": { backgroundColor: "#E57373" },
                                boxShadow: 3,
                              }}
                              endIcon={<MdClose />}
                              onClick={()=>{handleOpenModal(solicitud,"R")}}
                              >
                              Rechazar
                            </Button>
                          </Grid>
                          :
                          <></>
                        }
                      </Grid>
                      :
                      <Grid>
                          <Tooltip title={'Detalle'} placement="top" arrow>
                            <IconButton aria-label={'Detalle'}  color="primary" onClick={()=>{handleOpenModal(solicitud,"D")}}>
                              <MdEditDocument />
                            </IconButton>
                          </Tooltip>
                        </Grid>



                    }</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                {
                  showImpedimento ?
                  <TableCell colSpan={9} align="center">
                    No hay solicitudes registradas.
                  </TableCell>
                :
                  <TableCell colSpan={8} align="center">
                    No hay solicitudes registradas.
                  </TableCell>
                }
                
              </TableRow>
            )}
          </TableBody>
          
        </Table>
      </TableContainer>
      <TablePagination
          rowsPerPageOptions={rowsPerPage}
          component="div"
          count={constFilteredSolicitud.length}
          rowsPerPage={rowsperpage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
      />
      

      <SmallModal
        title='Detalle de la solicitud'
        open={isModalDetalle}
        onClose={handleCloseModal}
        content = {
          <>
            <Container component={Paper} elevation={3}>
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos Generales
              </Typography>
              <Typography variant="body1"><strong>Titulo:</strong> {datosProyecto.tituloProyecto}</Typography>
              <Typography variant="body1"><strong>Código de proyecto:</strong> {datosProyecto.codigoProyecto}</Typography>
              <Typography variant="body1"><strong>Fecha de inicio:</strong> {format(new Date(datosProyecto.fechaInicio), 'dd/MMM/yyyy',{locale: es})}</Typography>
              <Typography variant="body1"><strong>Fecha de fin:</strong> {format(new Date(datosProyecto.fechaFinal), 'dd/MMM/yyyy',{locale: es})}</Typography>
              <Typography variant="body1"><strong>Objetivo general:</strong>{datosProyecto.objetivoGeneral}</Typography>
            </Container>

            <Container component={Paper} elevation={3}>
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos de la solicitud
              </Typography>
              <Typography variant="body1"><strong>Estudiante: </strong> {detalleData.nombreEstudiante}</Typography>
              <Typography variant="body1"><strong>Carrera: </strong> {estudiante.nombrecarrera}</Typography>
              <Typography variant="body1"><strong>Descripción de la necesidad: </strong> {detalleData.descripcion}</Typography>
              <Typography variant="body1"><strong>Fecha de la solicitud: </strong> {detalleData.fechasolicitud}</Typography>
              <Typography variant="body1"><strong>Término: </strong>{detalleData.termino}</Typography>
              <Typography variant="body1"><strong>Responsable: </strong>{detalleData.nombreInvestigador}</Typography>
              <Typography variant="body1"><strong>Financiamiento: </strong>{detalleData.financiamientoTexto}</Typography>
              <Typography variant="body1"><strong>{detalleData.estadoPaso === "A" ? 'Horas otorgadas: ':'Horas de la solicitud: ' }  </strong>{ detalleData.estadoPaso === 'A' ? detalleData.horasOtorgadas : detalleData.horas}</Typography>
              <Typography variant="body1"><strong>Actividades: </strong>{detalleData.actividades}</Typography>
            </Container>
            <br></br>

            {
              detalleData.estadoPaso=='P' && !showImpedimento ?
              <Container component={Paper} elevation={3}>
                <Typography variant="h6" sx={{ marginTop: 2 }}>
                  {
                    tipoBoton =="A" ? 
                    <p>Aprobación de la solicitud</p>
                    :
                    <p>Rechazo de la solicitud</p>
                  }
                  
                </Typography>
                <AccionSolicitudAyudantia token={token} data={detalleData} estudiante={estudiante}  onClose={handleCloseModal} onResponse={handleResponseForm} tipobtn={tipoBoton} onResponseRechazo={handleResponseFormRechazo}/>
              </Container>
              :
              <></>
              
            }
            
          </>
          
        }
      
      />

      <SmallModal 
        title='Solicitudes a rechazar'
        open={isModalRechazar}
        onClose={handleCloseModalRechazo}
        content = {<>
        <ul>
          {
            solicitudesARechazar.map((obj, index)=>(
              <li key={index}>
                <p> <b>Estudiante: </b>{obj.nombreEstudiante +" "} <b>Proyecto: </b>{ obj.nombreProyecto+" " } <b>Investigador: </b>{obj.nombreInvestigador}</p>
              </li>
            ))
          }
        </ul>
        <AccionMultipleForm data={solicitudesARechazar} token={token} onClose={handleCloseModalRechazo } onResponse={handleResponseFormRechazo} tipoPersona={tipoPersona} aceptar={false}/>
      </>}
      
      />
    </Container>
    
  );
};
